module.exports = __webpack_public_path__ + "img/progress-bar-light-01.ba9a9815.png";